<div
  [formGroup]="changePasswordFG"
  class="flex flex-col gap-4"
>
  <flx-input class="flx-ds">
    <flx-label class="flx-ds mandatory">New Password</flx-label>
    <input
      [type]="showPassword() ? 'text' : 'password'"
      flxInput
      formControlName="password"
      placeholder="New Password"
      data-testId="new-password-input"
    />
    <button
      (click)="showPassword.set(!showPassword())"
      class="flx-ds p-0 neutral w-fit text-lg"
      variant="text"
      type="button"
      flxButton
      flxSuffix
    >
      <span
        [ngClass]="showPassword() ? 'ph-eye' : 'ph-eye-slash'"
        class="ph"
      ></span>
    </button>
    @if (submitted() && (passwordFC.errors || changePasswordFG.errors?.sameAsEmail)) {
      <flx-error>
        @if (passwordFC.errors) {
          @if (passwordFC.errors.required) {
            {{ passwordErrors.required }}
          } @else if (passwordFC.errors.minlength) {
            {{ passwordErrors.minlength }}
          } @else if (passwordFC.errors.maxlength) {
            {{ passwordErrors.maxlength }}
          } @else if (passwordFC.errors.pattern) {
            {{ passwordErrors.pattern }}
          }
        } @else if (changePasswordFG.errors?.sameAsEmail) {
          {{ passwordErrors.sameAsEmail }}
        }
      </flx-error>
    } @else {
      <flx-helper>{{ passwordHelperText }}</flx-helper>
    }
  </flx-input>

  <flx-input class="flx-ds">
    <flx-label class="flx-ds mandatory">Confirm New Password</flx-label>
    <input
      [type]="showConfirmPassword() ? 'text' : 'password'"
      flxInput
      placeholder="Confirm New Password"
      formControlName="confirmPassword"
      data-testId="confirm-password-input"
    />
    <button
      (click)="showConfirmPassword.set(!showConfirmPassword())"
      class="flx-ds p-0 neutral w-fit text-lg"
      variant="text"
      type="button"
      flxButton
      flxSuffix
    >
      <span
        [ngClass]="showConfirmPassword() ? 'ph-eye' : 'ph-eye-slash'"
        class="ph"
      ></span>
    </button>
    @if (submitted() && confirmPasswordFC.errors) {
      <flx-error>
        @if (confirmPasswordFC.errors.required) {
          Confirm password is required
        } @else if (confirmPasswordFC.errors.passwordMismatch) {
          Passwords must match
        }
      </flx-error>
    }
  </flx-input>
</div>
